export const PAST_MEETING_ROUTE = '/pastMeeting';
export const PAST_MEETING_PARTICIPANT_ROUTE = '/pastMeetingParticipant';
export const PAST_MEETING_TAB = '/dashboard/new/pastMeetings';
export const PAST_MEETING_GEO = 'geo';
export const PAST_MEETING_PARTICIPANTS = 'participants';

export const PAST_MEETING_REFRESH_TIME = 3 * 1000;
